'use strict';
import { newModalFromString } from 'components/modal'

var processBalanceAjaxCall = function (ajaxUrl, giftCardType, giftCardNumber, giftCardPin, captcha) {

    var gcType;
    if (giftCardType === 'Physical') {
        gcType = 'card';
    } else if (giftCardType === 'Electronic') {
        gcType = 'electronic';
    }
    if (document.querySelector('#g-recaptcha-response') != null && document.querySelector('#g-recaptcha-response').value != "") {
        captcha = document.querySelector('#g-recaptcha-response').value;
    }
    if (document.querySelector('#recaptcha-modal .g-recaptcha-response') != null && document.querySelector('#recaptcha-modal .g-recaptcha-response').value != "") {
        captcha = document.querySelector('#recaptcha-modal .g-recaptcha-response').value;
    }
    if (!captcha && captcha != null) {
        $('.no-robot').removeClass('hidden');
        $.spinner().stop();
        return;
    }

    $.ajax({
        url: ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
            giftCardType: giftCardType,
            giftCardNumber: giftCardNumber,
            giftCardPin: giftCardPin,
            captcha: captcha || ''
        },
        success: responseData => {
            $('.giftcard-checkbalance-error').addClass('hidden');
            $('.resocard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-error-expired').addClass('hidden');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.resocard-checkbalance-success').addClass('hidden');
            $('.js-digitalWallet-card-show').addClass('hidden');
            $('.resocard-checkbalance-error').addClass('hidden');
            $('.resocard-checkbalance-error-expired').addClass('hidden');
            $('.wrapper-content-slot').removeClass('hiddenGiftCard');
            $('.js-giftcard-error-message').addClass('hidden');
            if (!responseData.success) {
                if (responseData.message) {
                    $('.js-giftcard-error-message').text(responseData.message);
                    $('.js-giftcard-error-message').removeClass('hidden');
                } else if (responseData.isResocard) {
                    if (responseData.isExpired) {
                        // Display error expired reso card
                        $('.resocard-checkbalance-error-expired').removeClass('hidden');
                    } else {
                        $('.resocard-checkbalance-error').removeClass('hidden');
                    }
                } else {
                    if (responseData.isExpired) {
                        // Display error expired reso card
                        $('resocard-checkbalance-error-expired').removeClass('hidden');
                    } else {
                        // Not enough balance: display error
                        $('.giftcard-checkbalance-error').removeClass('hidden');
                    }
                }
            } else {
                if ($('.button-balance').data('clicked') === true) {
                    $('body').trigger('giftcardCheckBalance', {
                        'gcType': giftCardType,
                        'gcCode': giftCardNumber
                    });
                    $('.button-balance').data('clicked', false);
                } else if ($('.buttonApplyGiftcard').data('clicked') === true) {
                    $('body').trigger('giftcardApply', {
                        'gcType': giftCardType,
                        'gcCode': giftCardNumber
                    });
                    $('.buttonApplyGiftcard').data('clicked', false);
                }
                // Do fancy things in FE:

                if (responseData.isResocard) {
                    if (!responseData.giftcardCanBeApplied) {
                        $('.resocard-checkbalance-balance-error').removeClass('hidden');
                        return;
                    }
                } else {
                    if (!responseData.giftcardCanBeApplied) {
                        $('.giftcard-checkbalance-balance-error').removeClass('hidden');
                        return;
                    }
                }

                if (responseData.isResocard) {
                    $('.resocard-checkbalance-success').removeClass('hidden');
                    $('.resocard-checkbalance-balance').removeClass('hidden');
                    $('.js-digitalWallet-card-show').removeClass('hidden');
                    $('.resocard-checkbalance-balance').text(`${responseData.currency} ${responseData.amount}`);
                    $('.resocard-checkbalance-expired').text(`${responseData.expiryDate}`);
                } else {
                    $('.giftcard-checkbalance-success').removeClass('hidden');
                    $('.giftcard-checkbalance-balance').removeClass('hidden');
                    $('.js-digitalWallet-card-show').removeClass('hidden');
                    $('.giftcard-checkbalance-balance').text(`${responseData.currency} ${responseData.amount}`);
                    $('.giftcard-checkbalance-expired').text(`${responseData.expiryDate}`);
                }
                if (responseData.firstName) {
                    $('.js-giftcardNameToStamp').text('' + responseData.firstName);
                } else {
                    $('.js-giftcardNameToStamp').text('');
                }
            }
        },
        error: () => {
            // Display error with not enough balance
            $('.resocard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.giftcard-checkbalance-error-expired').addClass('hidden');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.resocard-checkbalance-success').addClass('hidden');
            $('.js-digitalWallet-card-show').addClass('hidden');
            $('.resocard-checkbalance-error').addClass('hidden');
            $('.giftcard-checkbalance-error').removeClass('hidden');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.js-giftcard-error-message').addClass('hidden');
        },
        complete: () => {
            try {
                grecaptcha.reset();
            } catch (e) {
                console.error(e); 
            }   
        }
    });
};
var digitalWalletModalListeners = function (digitalWalletModalHtml) {
    var giftCardNumber = $('form#form-gift-card input[name="inputCode"]').val();
    var giftCardPin = $('form#form-gift-card input[name="inputPin"]').val();

    const addCreditModal = newModalFromString(digitalWalletModalHtml, true, ['cc-dwallet-modal']);
    const checkBox = $(addCreditModal.modalBox).find('input[name$="digitalWalletPolicyContainer"]');
    addCreditModal.open();

    checkBox.on('change', function () {
        const $submitBtn = $(addCreditModal.modalBox).find('.js-digitalWallet-modal-submit');
        if ($(this).prop('checked')) {
            $submitBtn.removeClass('disabled');
        } else {
            $submitBtn.addClass('disabled');
        }
    });

    $(addCreditModal.modalBox).on('click', '.js-digitalWallet-modal-submit', function (e) {
        const confirmationUrl = $(e.currentTarget).data('add-credit');
        if (checkBox.prop('checked')) {
            $('.js-digitalWallet-policy-error').addClass('hidden');
            $.spinner().start();
            $.ajax({
                url: confirmationUrl,
                method: 'POST',
                data: {
                    cardNumber: giftCardNumber,
                    cardPin: giftCardPin
                },
                success: data => {
                    addCreditModal.close();
                    addCreditModal.destroy();
                    if (!data.success) {
                        $.spinner().stop();
                        errorModalBoxListeners(data.errorModalBoxHtml, data.errorCode);
                    } else {
                        sessionStorage.setItem('showDWalletPopup', '1');
                        $('body').trigger('giftcard:topup_giftcard', {'action': 'uploaded'}); // analytics
                        // Reloads the page
                        location.reload();
                    }
                },
                error: data => {
                    // error
                    $.spinner().stop();
                }
            });
        } else {
            $('.js-digitalWallet-policy-error').removeClass('hidden');
        }
    });

    // Destroys the modal
    $(addCreditModal.modalBox).on('click', '.js-digitalWallet-modal-close', function (e) {
        addCreditModal.close();
        addCreditModal.destroy();
        $('body').trigger('giftcard:topup_giftcard', {'action': 'close'}); // analytics
    });
}

var errorModalBoxListeners = function (errorModalBoxHtml, errorCode) {
    const errorModalBox = newModalFromString($(errorModalBoxHtml).first().html(), true, ['cc-dwallet-modal']);
    errorModalBox.open();

    $('body').trigger('customer:digital_wallet_topup_error', {
        'step': 'step3',
        'errorCode': errorCode
    });

    $(errorModalBox.modalBox).on('click', '.js-digitalWallet-modal-close', function (e) {
        errorModalBox.close();
        errorModalBox.destroy();
    });
}

module.exports = {
    showDigitalWalletPopup: function () {
        if (sessionStorage.getItem('showDWalletPopup')) {
            sessionStorage.removeItem('showDWalletPopup');
            const $popup = $('.js-dwallet-popup');
            $popup.addClass('active');
            const popupTimer = setTimeout(() => $popup.removeClass('active'), 5000);
            $popup.find('.js-dwallet-popup-close').one('click', () => {
                clearTimeout(popupTimer);
                $popup.removeClass('active');
            });
        }
    },
    retriveGiftCardBalanceFooter: function () {
        $('body').on('click', 'form#form-gift-card .button', function (e) {
            e.preventDefault();
            var giftCardType = $('form#form-gift-card input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('form#form-gift-card input[name="inputCode"]').val();
            var giftCardPin = $('form#form-gift-card input[name="inputPin"]').val();
            var captcha = document.querySelector('#g-recaptcha-response').value;

            if (window.location.href.indexOf('tezenis') > -1) {
                processBalanceAjaxCall($('form#form-gift-card').data('url'), giftCardType, giftCardNumber, giftCardPin, captcha);
            }
        });
        $('body').on('click', '.js-digitalWallet-addCredit-submit', function (e) {
            $('body').trigger('giftcard:topup_giftcard', {'action': 'upload'}); // analytics
            digitalWalletModalListeners($('#digitalWalletModal').html());
        });
    },
    retriveGiftCardBalance: function () {
        $('body').on('click', 'form.giftCardBalanceModalForm .js-check-balance', function () {
            var giftCardType = $('form.giftCardBalanceModalForm input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('form.giftCardBalanceModalForm #giftCardNumber').val() === undefined || '' ? $('#giftCardNumberModal').val() : $('form.giftCardBalanceModalForm #giftCardNumber').val();
            var giftCardPin = $('form.giftCardBalanceModalForm #giftCardPin').val();
            $('#giftCardFormGroup #giftCardNumber').val(giftCardNumber);
            $('#giftCardFormGroup #giftCardPin').val(giftCardPin);
            if (giftCardType === 'Physical') {
                if ($('#giftCardPane input[type="radio"]#giftCardElectronic:checked').length) {
                    $('#giftCardPane input[type="radio"]#giftCardPhysical').trigger('click');
                }
            } else {
                if ($('#giftCardPane input[type="radio"]#giftCardPhysical:checked').length) {
                    $('#giftCardPane input[type="radio"]#giftCardElectronic').trigger('click');
                }
            }

            var captcha = document.querySelector('#recaptcha-modal .g-recaptcha-response') ? document.querySelector('#recaptcha-modal .g-recaptcha-response').value : null;

            processBalanceAjaxCall($('form.giftCardBalanceModalForm').data('url'), giftCardType, giftCardNumber, giftCardPin, captcha);
            
        });
    },

    applyGiftcard: function () {
        $('body').on('click', '.buttonApplyGiftcard', function () {
            var captcha = (document.querySelector('#g-recaptcha-response')?.value 
                || document.querySelector('#recaptcha-modal .g-recaptcha-response')?.value 
                || '');
            if (!captcha) {
                $('.no-robot').removeClass('hidden');
                return;
            }
            var giftCardType = $('input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var giftCardNumber = $('#giftCardNumber').val();
            var giftCardPin = $('#giftCardPin').val();
            let giftCardTypeAnalytics = giftCardType === 'Physical' ? 'card' : 'electronic';

            // Reset coupon section state
            $('.checkbox-promo-block, .loyalty-coupons-container').removeClass('disabled');
            $('.checkout-applied-giftcard-message').addClass('hide');

            $.ajax({
                url: $('#giftCardFormGroup').data('url'),
                method: 'POST',
                dataType: 'json',
                data: {
                    giftCardType: giftCardType,
                    giftCardNumber: giftCardNumber,
                    giftCardPin: giftCardPin
                },
                success: responseData => {
                    $('.giftcard-amount-feedback').removeClass('hidden');
                    $('.gift-card-messages').addClass('hidden');
                    if (!responseData.success) {
                        $('.gift-card-error').removeClass('hidden').text(responseData.message);
                        $('.giftcard-applied').removeClass('multipaymentToSelect');
                        $('.giftCardRemainedAmount').text('');
                    } else {
                        $('body').trigger('giftcardApply', {
                            'gcType': giftCardTypeAnalytics
                        });
                        $('.giftcard-modal-block').addClass('hidden');
                        if (responseData.isResocard) {
                            $('.display-resocard').removeClass('hidden');
                        } else {
                            $('.display-giftcard').removeClass('hidden');
                        }
                        $('.item-giftcard').removeClass('hidden');
                        $('.giftcard-total').text(responseData.amountText);
                        $('.giftcard-applied').removeClass('hidden').html(responseData.message);
                        $('#giftCardFormGroup .buttonApplyGiftcard').addClass('hide');
                        $('#giftCardFormGroup .buttonRemoveGiftcard').removeClass('hide');
                        $('.giftCardNumberField, .giftCardPinField').addClass('giftcardSubmitted');
                        $('.giftCardRemainedAmount').removeClass('hidden').html(responseData.messageRemainedAmount);

                        // Disable coupon application (code and loyalty) when EGC is applied
                        $('.checkbox-promo-block, .loyalty-coupons-container').addClass('disabled');
                        $('.checkout-applied-giftcard-message').removeClass('hide');

                        if (responseData.coversTotalAmount) {
                            $('#GIFT_CARD').click();
                            $('.drawer input[name$="paymentMethod"]:not(#GIFT_CARD, #RESO_CARD)').attr('disabled', true);
                            $('.giftCardDrawer .giftcard-submit-payment').removeClass('hidden');
                            $('.giftCardRemainedAmount').removeClass('giftcardMultiPaymentAmount');
                        } else {
                            $('.giftCardRemainedAmount').addClass('giftcardMultiPaymentAmount');
                            // Re-enable express buttons except PayPal (incompatible with GiftCard multipayment)
                            $('.js-express-button').not('.js-paypal-container').removeClass('disableExpressButton');
                            $('.js-paypal-container').addClass('disableExpressButton');
                            $('.giftcard-applied').addClass('multipaymentToSelect');
                            if ($('input#DW_APPLE_PAY:checked').length > 0 && $('#apple-pay-btn').length > 0) {
                                $('.applepay-tab-header input').trigger('change');
                            }
                        }
                        // For multipayment
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: responseData.order,
                            customer: responseData.customer,
                            coversTotalAmount: responseData.coversTotalAmount,
                            action: 'addGiftcard'
                        });
                        $('.tingle-modal button.close').trigger('click');
                    }
                },
                error: () => {
                    $('.giftcard-modal-block').addClass('hidden');
                    $('.gift-card-error').removeClass('hidden');
                },
                complete: () => {
                    try {
                        grecaptcha.reset();
                        $('.no-robot').addClass('hidden');
                    } catch (e) {
                        console.error(e); 
                    }   
                }
            });
        });
    },

    handleGiftcardInput: function () {
        $('body').on('input', '#giftCardFormGroup .giftCardNumberField,#giftCardFormGroup .giftCardPinField', function (e) {
            $('.giftcard-amount-feedback').addClass('hidden');
            $('.gift-card-error').addClass('hidden');
           // $('.js-digitalWallet-card-show').removeClass('hidden'); TODO
        });
    }
};
